<template>
  <div>
    <div id="partner" class="columns is-multiline is-mobile partner invisible">
      <img
        @click="toPage(item.primary.link[0].text)"
        v-for="(item, i) in partner"
        :key="i"
        :src="item.primary.img.url"
        :style="`max-height:${imgHeight}px`"
        class="partner-img is-hidden-mobile"
      />
      <div
        class="column is-3-desktop is-6-tablet is-6-mobile is-hidden-tablet"
        v-for="(item, i) in partner"
        :key="`parner-${i}`"
      >
        <img
          @click="toPage(item.primary.link[0].text)"
          :src="item.primary.img.url"
          :style="`max-height:${imgHeight}px`"
          class="partner-img"
        />
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  props: ["imgHeight", "animate"],
  data() {
    return {
      partner: [],
    };
  },
  computed: {
    ref() {
      return this.$store.getters["cms/ref"];
    },
    language() {
      return this.$store.getters["language/language"];
    },
  },
  watch: {
    language() {
      this.getPartner();
    },
  },
  mounted() {
    this.getPartner();
    if (this.animate) {
      $(document).scroll(this.setAnimation);
    } else {
      $(`#partner`).removeClass("invisible");
    }
  },
  methods: {
    async getPartner() {
      const params = {
        ref: this.ref,
        q: `[[at(document.tags, ["Partner","${this.language}"])]]`,
      };
      const res = await this.$http.get(
        process.env.VUE_APP_URL + "/api/v2/documents/search",
        { params }
      );
      this.partner = res.data.results[0].data.body;
      console.log(this.partner);
      this.$emit("onloadTitle", res.data.results[0].data.name[0].text);
    },
    setAnimation() {
      const height = $(window).scrollTop() + $(window).height();
      if ($(`#partner`).length > 0) {
        if (height > $(`#partner`).offset().top) {
          $(`#partner`)
            .addClass("animate__animated animate__fadeInUp")
            .removeClass("invisible");
        }
      }
    },
    toPage(url) {
      console.log(url);
      if (url.startsWith("http")) {
        let win = window.open(url, "_blank");
        win.focus();
      } else {
        this.$router.push(url);
      }
    },
  },
};
</script>

<style scoped>
.partner-img {
  width: auto;
  cursor: pointer;
  padding: 0px;
}
.partner {
  justify-content: space-between;
  margin: 0;
}
</style>